//dependencies import ==>
import React, { useEffect, useRef, useState } from "react";
import Drawer from "@material-ui/core/Drawer";
import Popover from "react-popover";
// assets and scss import ==>
import Info from "../../assets/info.png";
import success_tick from "../../assets/dashboard/success_tick.svg";
import "./adminEditProfile.scss";
import Reset from "../../assets/reset.svg";
import warningImg from "../../assets/cancelled.svg";
import uploadIcon from "../../assets/upload-temp.png";
import crossIcon from "../../assets/crossIcon.svg";
import swal from "sweetalert";
//project file import ==>
import UploadToggleButton from "./UploadToggelButton";
import PrePrintStationaryDisplay from "./PrePrintedStationary";
import {
  CUSTOM_DOCTOR_ERX_DETAILS,
  GET_DOCTOR_ERX_DETAILS,
  PDF_GENERATOR,
} from "./AdminEditProfileApiHandler/apiConstant";
import PrimaryButton from "../common/Buttons/PrimaryButton";
import SecondaryButton from "../common/Buttons/SecondaryButton";
import { RX_PROPERTIES, UPLOADING_FOR } from "./constant";
import Loader from "../UI Component/Loader/Loader";
import C2CMiddlePopup from "../common/Popups/C2CMiddlePopup";
import PdfContainer from "../UI Component/DocumentViewer/PdfContainer";
import AdminDoctorUploadFile from "./AdminDoctorUploadFile";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
import { c2cGetApiHandler, c2cPostApiHandler } from "../../Util/c2cApiHandler";

//<==

const AdminEditConsultantProfile = (props) => {
  //const ==>
  const { doctorId, clinicId, doctorData } = props;
  const [uploadTemplate, setUploadTemplate] = useState({});
  const [loader, setLoader] = useState(false);
  const [iconType, setIconType] = useState("");
  const [titleMsg, setTitleMsg] = useState("");
  const [values, setValues] = useState({});
  const [subtitleMsg, setSubtitleMsg] = useState("");
  const [showSuccessFailurePopup, setShowSuccessFailurePopup] = useState(false);
  const [uploadFooterTemplate, setUploadFooterTemplate] = useState({});
  const [customMarginVal, setCustomMarginVal] = useState({ ...RX_PROPERTIES });
  const [printMarginUnit, setPrintMarginUnit] = useState("cm");
  const [PmrActClsName, setPmrActClsName] = useState("mrdact-rlbt");
  const [isReset, setIsReset] = useState(false);
  const [preprintStationaryDisplayView, setPreprintStationaryDisplayView] =
    useState(false);
  const [open, setOpen] = useState(false);
  const [fileDetails, setFileDetails] = useState({
    fileURL: "",
    fileName: "Preview Prescription",
    fileType: ".pdf",
  });
  const [dataHeader, setDataHeader] = useState("");
  const [dataFooter, setDataFooter] = useState("");
  const [documentShow, setDocumentShow] = useState(false);
  const clearSelectedFileHeader = useRef(() => ({ current: null }));
  const clearSelectedFileFooter = useRef(() => ({ current: null }));

  let details = {
    clinicId: clinicId,
    doctorId: doctorId,
  };
  //<==

  //UseEffect  ==>
  useEffect(() => {
    getDoctorProfileAPICall(details);
  }, []);

  useEffect(() => {
    CustmrCheck();
  }, [customMarginVal]);
  //<==

  //api calls ==>
  const getDoctorProfileAPICall = (doctorProfileDetails) => {
    setLoader(true);
    c2cGetApiHandler(GET_DOCTOR_ERX_DETAILS(doctorProfileDetails))
      .then(([res, err]) => {
        if (!err) {
          if (res?.data?.statusCode === 200) {
            setLoader(false);
            setValues(res?.data);
            const customMarginDimensions =
              res?.data?.prescription_data?.doctor_profile_details
                ?.custom_margin_dimensions;
            if (customMarginDimensions) {
              setCustomMarginVal({
                rxTop: customMarginDimensions.rxTop || "",
                rxLeft: customMarginDimensions.rxLeft || "",
                rxBottom: customMarginDimensions.rxBottom || "",
                rxRight: customMarginDimensions.rxRight || "",
              });

              setPrintMarginUnit(customMarginDimensions.unit);
            } else {
              setCustomMarginVal({
                rxTop: "",
                rxLeft: "",
                rxBottom: "",
                rxRight: "",
              });
              setPrintMarginUnit("");
            }

            setPreprintStationaryDisplayView(
              res?.data?.prescription_data?.doctor_profile_details
                ?.custom_margins_enabled
            );
            let headerTemplate = {},
              footerTemplate = {};
            if (!res?.data?.custom_erx_enabled) {
              headerTemplate = res?.data?.prescription_data
                ?.doctor_hospital_details[0]?.enable_custom_header
                ? res?.data?.prescription_data?.doctor_hospital_details[0]
                    ?.custom_header_image
                : {};
              footerTemplate = res?.data?.prescription_data
                ?.doctor_hospital_details[0]?.enable_custom_footer
                ? res?.data?.prescription_data?.doctor_hospital_details[0]
                    ?.custom_footer_image
                : {};
            } else {
              headerTemplate =
                res?.data?.prescription_data?.doctor_hospital_details[0]
                  ?.custom_header_image;
              footerTemplate =
                res?.data?.prescription_data?.doctor_hospital_details[0]
                  ?.custom_footer_image;
            }
            setUploadFooterTemplate({
              ...footerTemplate,
            });
            setUploadTemplate({
              ...headerTemplate,
            });
          }
        }
      })
      .catch((err) => {
        setLoader(false);
        C2CConsole.log("err", err);
      });
  };

  const updateProfileAPICall = () => {
    let payload = {
      custom_erx_enabled: !isReset,
      doctor_id: doctorId,
      footer_image: {
        file_name: uploadFooterTemplate?.name,
        file_size: uploadFooterTemplate?.file_size_in_mb,
        ...(dataFooter
          ? { file_path: dataFooter }
          : { file_path: uploadFooterTemplate?.file_path || "" }),
        file_mime_type: uploadFooterTemplate?.file_type,
        file_type: "doctor_rx_footer",
      },
      header_image: {
        file_name: uploadTemplate?.name,
        file_size: uploadTemplate?.file_size_in_mb,
        ...(dataHeader
          ? { file_path: dataHeader }
          : { file_path: uploadTemplate?.file_path || "" }),
        file_mime_type: uploadTemplate?.file_type,
        file_type: "doctor_rx_header",
      },
      custom_margin_enabled: preprintStationaryDisplayView,
      custom_margins: {
        unit: printMarginUnit,
        ...customMarginVal,
      },
    };
    setLoader(true);
    c2cPostApiHandler(CUSTOM_DOCTOR_ERX_DETAILS(details), payload)
      .then(([res, error]) => {
        setLoader(false);
        if (res?.data?.statusCode === 200) {
          setShowSuccessFailurePopup(true);
          setIconType("success");
          setTitleMsg("Success");
          setSubtitleMsg(res?.data?.message);
        } else {
          setShowSuccessFailurePopup(true);
          setIconType("error");
          setTitleMsg("Error");
          setSubtitleMsg(res?.data?.message);
        }
      })
      .catch((error) => {
        setLoader(false);
        C2CConsole.error(error);
      });
  };

  const previewTemplate = () => {
    debugger;
    setLoader(true);
    let data = {};
    delete values["statusCode"];
    delete values["doctor_id"];
    data = values;
    let prescription_data = {};
    if (
      preprintStationaryDisplayView ||
      Object.keys(uploadTemplate).length != 0 ||
      Object.keys(uploadFooterTemplate).length != 0
    ) {
      if (
        data.prescription_data &&
        data.prescription_data.doctor_hospital_details[0]
      ) {
        prescription_data.prescription_data = {
          ...values?.prescription_data,
          doctor_hospital_details: [
            {
              ...values?.prescription_data?.doctor_hospital_details[0],
              custom_header_image: { ...uploadTemplate },
              custom_footer_image: { ...uploadFooterTemplate },
              enable_custom_header: uploadTemplate?.presigned_url
                ? true
                : false,
              enable_custom_footer: uploadFooterTemplate?.presigned_url
                ? true
                : false,
            },
          ],
          doctor_profile_details: {
            ...values?.prescription_data?.doctor_profile_details,
            custom_margins_enabled: preprintStationaryDisplayView,
          },

          textual: {
            ...values?.prescription_data?.textual,
            doctor_hospital_details: [
              {
                ...values?.prescription_data?.textual
                  ?.doctor_hospital_details[0],
                custom_header_image: { ...uploadTemplate },
                custom_footer_image: { ...uploadFooterTemplate },
                enable_custom_header: uploadTemplate?.presigned_url
                  ? true
                  : false,
                enable_custom_footer: uploadFooterTemplate?.presigned_url
                  ? true
                  : false,
              },
            ],
            doctor_profile_details: {
              ...values?.prescription_data?.doctor_profile_details,
              custom_margins_enabled: preprintStationaryDisplayView,
            },
          },
        };
      }
      prescription_data.custom_margins_enabled = preprintStationaryDisplayView;

      prescription_data.custom_margin_dimensions = {
        unit: printMarginUnit,
        rxLeft: customMarginVal.rxLeft,
        rxRight: customMarginVal.rxRight,
        rxTop: customMarginVal.rxTop,
        rxBottom: customMarginVal.rxBottom,
      };
    } else {
      prescription_data = {
        ...values,
        prescription_data: {
          ...values?.prescription_data,
          doctor_hospital_details: [
            {
              ...values?.prescription_data?.doctor_hospital_details[0],
              custom_header_image: { ...uploadTemplate },
              custom_footer_image: { ...uploadFooterTemplate },
              enable_custom_header: uploadTemplate?.presigned_url
                ? true
                : false,
              enable_custom_footer: uploadFooterTemplate?.presigned_url
                ? true
                : false,
            },
          ],
          doctor_profile_details: {
            ...values?.prescription_data?.doctor_profile_details,
            custom_margins_enabled: preprintStationaryDisplayView,
          },

          textual: {
            ...values?.prescription_data?.textual,
            doctor_hospital_details: [
              {
                ...values?.prescription_data?.textual
                  ?.doctor_hospital_details[0],
                custom_header_image: { ...uploadTemplate },
                custom_footer_image: { ...uploadFooterTemplate },
                enable_custom_header: uploadTemplate?.presigned_url
                  ? true
                  : false,
                enable_custom_footer: uploadFooterTemplate?.presigned_url
                  ? true
                  : false,
              },
            ],
            doctor_profile_details: {
              ...values?.prescription_data?.doctor_profile_details,
              custom_margins_enabled: preprintStationaryDisplayView,
            },
          },
        },
      };
    }
    c2cPostApiHandler(PDF_GENERATOR, prescription_data)
      .then((response) => {
        if (response[0]?.data?.data) {
          const base64String = arrayBufferToBase64(response[0]?.data?.data);
          fileDetails.fileURL = base64String;
          setFileDetails(fileDetails);
          setLoader(false);
          setDocumentShow(true);
        } else {
          setLoader(false);
          swal({
            title: "Sorry",
            text: "Prescription could not be downloaded",
            icon: "warning",
          });
        }
      })
      .catch(function (error) {
        setLoader(false);
        swal({
          title: "Sorry",
          text: "Prescription could not be downloaded",
          icon: "warning",
        });
      });
  };

  //<==

  //Action ==>

  const handleHeaderAfterUpload = (data) => {
    setIsReset(false);
    setUploadTemplate(data);
    let tempValue = { ...values };
    tempValue["prescription_data"]["doctor_hospital_details"][0][
      "custom_header_image"
    ] = { ...data };
    setValues({ ...tempValue });
  };

  const handleFooterAfterUpload = (data) => {
    setIsReset(false);
    setUploadFooterTemplate(data);
    let tempValue = { ...values };
    tempValue["prescription_data"]["doctor_hospital_details"][0][
      "custom_footer_image"
    ] = { ...data };
    setValues({ ...tempValue });
  };

  function arrayBufferToBase64(buffer) {
    let binary = "";
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  const renderDocument = (width) => {
    if (documentShow) {
      return (
        <PdfContainer
          cancelHandler={() => closeNotification()}
          url={`data:application/pdf;base64,${fileDetails?.fileURL}`}
          fileName={fileDetails?.fileName}
          fileType={fileDetails?.fileType}
          width={width || ""}
        />
      );
    }
  };

  const closeNotification = () => {
    setDocumentShow(false);
    setFileDetails({
      fileName: "Preview Prescription",
      fileURL: "",
      fileType: "",
    });
  };

  const handleClosePopup = () => {
    setShowSuccessFailurePopup(false);
  };

  const handelReset = () => {
    setIsReset(true);
    setDataFooter("");
    setDataHeader("");
    if (clearSelectedFileHeader.current) clearSelectedFileHeader.current();
    if (clearSelectedFileFooter.current) clearSelectedFileFooter.current();
    let tempDetails = { ...details, isReset: false };
    getDoctorProfileAPICall(tempDetails);
  };

  const handelSubmit = () => {
    updateProfileAPICall();
  };

  const CustmrCheck = () => {
    if (
      customMarginVal.rxRight &&
      customMarginVal.rxLeft &&
      customMarginVal.rxTop &&
      customMarginVal.rxBottom
    ) {
      setPmrActClsName("mract-rlbt");
    } else if (
      customMarginVal.rxRight &&
      customMarginVal.rxLeft &&
      customMarginVal.rxBottom
    ) {
      setPmrActClsName("mract-rlb");
    } else if (
      customMarginVal.rxRight &&
      customMarginVal.rxTop &&
      customMarginVal.rxBottom
    ) {
      setPmrActClsName("mract-rbt");
    } else if (
      customMarginVal.rxRight &&
      customMarginVal.rxTop &&
      customMarginVal.rxLeft
    ) {
      setPmrActClsName("mract-rlt");
    } else if (
      customMarginVal.rxBottom &&
      customMarginVal.rxTop &&
      customMarginVal.rxLeft
    ) {
      setPmrActClsName("mract-lbt");
    } else if (customMarginVal.rxRight && customMarginVal.rxLeft) {
      setPmrActClsName("mract-rl");
    } else if (customMarginVal.rxRight && customMarginVal.rxBottom) {
      setPmrActClsName("mract-rb");
    } else if (customMarginVal.rxRight && customMarginVal.rxTop) {
      setPmrActClsName("mract-rt");
    } else if (customMarginVal.rxLeft && customMarginVal.rxBottom) {
      setPmrActClsName("mract-lb");
    } else if (customMarginVal.rxLeft && customMarginVal.rxTop) {
      setPmrActClsName("mract-lt");
    } else if (customMarginVal.rxBottom && customMarginVal.rxTop) {
      setPmrActClsName("mract-bt");
    } else if (customMarginVal.rxRight) {
      setPmrActClsName("mract-r");
    } else if (customMarginVal.rxLeft) {
      setPmrActClsName("mract-l");
    } else if (customMarginVal.rxTop) {
      setPmrActClsName("mract-t");
    } else if (customMarginVal.rxBottom) {
      setPmrActClsName("mract-b");
    } else {
      setPmrActClsName("mrdact-rlbt");
    }
  };

  const handleMarginChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (printMarginUnit == "cm" && value <= 10) {
      if (
        e.target.name == "rxLeft" ||
        e.target.name == "rxRight" ||
        e.target.name == "rcptLeft" ||
        e.target.name == "rcptRight"
      ) {
        if (value <= 5) {
          setCustomMarginVal({
            ...customMarginVal,
            [name]: value,
          });
        } else {
          setCustomMarginVal({
            ...customMarginVal,
            [name]: "",
          });
        }
      } else {
        setCustomMarginVal({
          ...customMarginVal,
          [name]: value,
        });
      }
    } else if (printMarginUnit == "in" && value <= 3.93701) {
      if (
        e.target.name == "rxLeft" ||
        e.target.name == "rxRight" ||
        e.target.name == "rcptLeft" ||
        e.target.name == "rcptRight"
      ) {
        if (value <= 1.9685) {
          setCustomMarginVal({
            ...customMarginVal,
            [name]: value,
          });
        } else {
          setCustomMarginVal({
            ...customMarginVal,
            [name]: "",
          });
        }
      } else {
        setCustomMarginVal({
          ...customMarginVal,
          [name]: value,
        });
      }
    } else {
      setCustomMarginVal({
        ...customMarginVal,
        [name]: "",
      });
    }
  };

  const handleStationaryDisplay = () => {
    setIsReset(false);
    setPreprintStationaryDisplayView(!preprintStationaryDisplayView);
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const getHoverTitle = () => {
    return <span className="icon-text">Reset Erx to C2C Settings</span>;
  };

  //create UI ==>

  const displaySuccessFailurePopup = () => {
    return (
      <>
        {showSuccessFailurePopup && (
          <C2CMiddlePopup
            openPopup={showSuccessFailurePopup}
            dialogClassName="admin-doctor-edit-profile-popup"
            hideCloseIcon={true}
            titleImg={iconType === "success" ? success_tick : warningImg}
            title={titleMsg}
            subtitle={subtitleMsg}
            middleBtn="Okay"
            handleMiddleBtnClick={handleClosePopup}
          />
        )}
      </>
    );
  };

  const createHeaderUI = () => {
    return (
      <div className="box">
        <div
          id="accordion1"
          className={`accordion ${
            preprintStationaryDisplayView ? "is-Divdisabled" : ""
          }`}
        >
          <div className="toggel-view">
            <div
              className={`card-header ${
                preprintStationaryDisplayView ? "collapsed" : ""
              }`}
              data-toggle="collapse"
              href="#collapseOne"
            >
              <span className="circle_plus_minus"></span>
              <a className="">Default C2C Header (Personal Details)</a>
            </div>
            <a className="card-title"></a>
          </div>

          <div
            id="collapseOne"
            data-parent="#accordion1"
            className={`collapse ${
              preprintStationaryDisplayView ? "" : "show"
            }`}
          >
            <UploadToggleButton
              isSelected={true}
              titleImg={uploadIcon}
              title={"Upload Header Template"}
            />
            <AdminDoctorUploadFile
              setDataKey={setDataHeader}
              setClearSelectedFile={(fun) => {
                if (clearSelectedFileHeader.current)
                  clearSelectedFileHeader.current = fun;
              }}
              clinic_id={clinicId}
              doctor_id={doctorId}
              use_case="doctor_rx_header_image"
              uploadingFor={UPLOADING_FOR.OTHER_CLINIC}
              title="Header Template"
              fileValidationLabel="Size limit: 5MB"
              setUploadedFile={handleHeaderAfterUpload}
              uploadedFile={uploadTemplate}
              error={""}
            />
          </div>
        </div>
      </div>
    );
  };

  const createFooterUI = () => {
    return (
      <div className="box">
        <div
          id="accordion2"
          className={`accordion ${
            preprintStationaryDisplayView ? "is-Divdisabled" : ""
          }`}
        >
          <div className="toggel-view">
            <div
              className={`card-header ${
                preprintStationaryDisplayView ? "collapsed" : ""
              }`}
              data-toggle="collapse"
              href="#collapseTwo"
            >
              <span className="circle_plus_minus"></span>
              <a className="card-title">
                Default C2C Footer (Clinic/Hospital Details)
              </a>
            </div>
            <a className="card-title"></a>
          </div>
          <div
            id="collapseTwo"
            className={`collapse ${
              preprintStationaryDisplayView ? "" : "show"
            }`}
            data-parent="#accordion2"
          >
            <UploadToggleButton
              title="Upload Footer Template"
              isSelected={true}
              titleImg={uploadIcon}
            />
            <AdminDoctorUploadFile
              setDataKey={setDataFooter}
              setClearSelectedFile={(fun) => {
                if (clearSelectedFileFooter.current) {
                  clearSelectedFileFooter.current = fun;
                }
              }}
              clinic_id={clinicId}
              use_case="doctor_rx_footer_image"
              doctor_id={doctorId}
              uploadingFor={UPLOADING_FOR.OTHER_CLINIC}
              title="Footer Template"
              fileValidationLabel="Size limit: 5MB"
              setUploadedFile={handleFooterAfterUpload}
              uploadedFile={uploadFooterTemplate}
              error={""}
            />
          </div>
        </div>
      </div>
    );
  };

  const createPreFilledStationaryContainUI = () => {
    return (
      <div className="prefilled-stationary-checkbox">
        <div
          className="main-prefiled hover-pointer"
          onClick={handleStationaryDisplay}
        >
          <label
            className="pre-Stationary-checkBox hover-pointer"
            style={
              preprintStationaryDisplayView
                ? { backgroundColor: "#17bae0" }
                : null
            }
          >
            <span>
              {preprintStationaryDisplayView ? (
                <i className="fa fa-check facheck"></i>
              ) : null}
            </span>
          </label>
          <span className="check-box-ui">
            Do You Have Pre-Printed Stationery?
          </span>
        </div>
        <div className="customContainer">
          <div className="customText" onClick={handelReset}>
            <img src={Reset} alt="Reset" className="resetIcon" />
            Reset
          </div>
          <Popover
            isOpen={open}
            preferPlace="below"
            place={null}
            body={getHoverTitle()}
          >
            <img
              src={Info}
              alt=""
              className="infoImage"
              onMouseOver={handleTooltipOpen}
              onMouseOut={handleTooltipClose}
            />
          </Popover>
        </div>
      </div>
    );
  };

  const createTopContainUI = () => {
    return (
      <div class="show-detail-view">
        <div>Details</div>
        <div>Show in Prescription</div>
      </div>
    );
  };

  const createProfileImageUI = () => {
    return (
      <div className="doctor-profile-container">
        <div className="profile-img-container no-image">
          {doctorData?.doctor_profile_picture_url.length !== 0 ? (
            <img
              src={doctorData.doctor_profile_picture_url[0]}
              className="profile_img"
              alt="profileImage"
              style={{
                width: 100,
                height: 100,
                borderRadius: "50%",
                border: "1px solid",
                borderColor: "white",
              }}
            />
          ) : (
            doctorData?.doctor_first_name?.charAt(0)
          )}
        </div>
        <div className="profile-detail-container">
          <div className="doctor-name">
            {" "}
            {doctorData?.doctor_prefix_name
              ? `${doctorData?.doctor_prefix_name}. ${doctorData?.doctor_first_name} ${doctorData?.doctor_middle_name} ${doctorData?.doctor_last_name}`
              : `${doctorData?.doctor_first_name} ${doctorData?.doctor_middle_name} ${doctorData?.doctor_last_name}`}
          </div>
          <div className="doctor-designation">
            {doctorData?.doctor_specialization}
          </div>
        </div>
      </div>
    );
  };

  const createTopHeaderUI = () => {
    return (
      <div className="main-container">
        <div className="header-view">
          <h4 className="update-profile-view">Update Profile</h4>
        </div>
        <img
          className="closeIcon-text"
          src={crossIcon}
          alt=""
          onClick={props.closeView}
        />
      </div>
    );
  };

  const createSaveAndResetButton = () => {
    return (
      <div className="button-container">
        <PrimaryButton title={"Preview"} handleButtonClick={previewTemplate} />
        <span className="button-space"> </span>
        <SecondaryButton
          title={"Save Changes"}
          handleButtonClick={handelSubmit}
        />
      </div>
    );
  };

  const createPreStationaryUI = () => {
    return (
      <div>
        <div className="box" style={{ marginBottom: 60 }}>
          <div id="accordion3" className=" accordion">
            <div className="prefill-display">
              <div
                className={`card-header ${
                  preprintStationaryDisplayView ? "collapsed" : ""
                }`}
                data-toggle="collapse"
                href="#collapseThree"
                style={
                  !preprintStationaryDisplayView
                    ? { pointerEvents: "none" }
                    : null
                }
              >
                <span className="circle_plus_minus"></span>
                <a className="">Pre-Printed Stationary </a>
              </div>
              <label
                className="pre-Staionary-checkBox"
                style={
                  preprintStationaryDisplayView
                    ? { backgroundColor: "#17bae0" }
                    : null
                }
              >
                <span>
                  {preprintStationaryDisplayView ? (
                    <hr className="pre-Staionary-act-hr" />
                  ) : null}
                </span>
              </label>
            </div>
            <div
              id="collapseThree"
              className={`card-body collapse ${
                preprintStationaryDisplayView ? "show" : "hide"
              }`}
            >
              <PrePrintStationaryDisplay
                selectTitle={"select your unit"}
                titleUnit1={"cm"}
                titleUnit2={"inch"}
                subtitle={"Prescription"}
                customMarginVal={customMarginVal}
                printMarginUnit={printMarginUnit}
                setCustomMarginVal={setCustomMarginVal}
                setPrintMarginUnit={setPrintMarginUnit}
                PmrActClsName={PmrActClsName}
                handleMarginChange={handleMarginChange}
                preprintStationaryDisplayView={preprintStationaryDisplayView}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  //<==

  return (
    <>
      {loader ? <Loader /> : ""}
      <Drawer
        anchor={"right"}
        open={props.openView}
        onClose={props.closeView}
        className="admin-edit_profile_drawer"
      >
        <div id="admin-edit-profile">
          {createTopHeaderUI()}
          {createProfileImageUI()}
          {createTopContainUI()}
          {createPreFilledStationaryContainUI()}
          {createHeaderUI()}
          {createFooterUI()}
          {createPreStationaryUI()}
          {createSaveAndResetButton()}
        </div>
        {displaySuccessFailurePopup()}
        {renderDocument("98%")}
      </Drawer>
    </>
  );
};

export default AdminEditConsultantProfile;
